import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button } from 'loyal-react'
import ReactPlaceholder from 'react-placeholder'
import Placeholder from './Placeholder'

const ViewProdutOrderDetail = props => {
  return (
    <ReactPlaceholder ready={props.ready} customPlaceholder={<Placeholder />}>
      <Link
        className='mx-auto'
        to={`/order/${props.parentOrderId}/${props.orderId}/product/${
          props.productId
        }?previousRoute=${props.previousRoute}`}
        title={`Ver as informações do pedido ${props.orderId}`}
      >
        <Button id={`btnDetalhe-${props.parentOrderId}-${props.orderId}`} className='btn btn-sm' text='Ver detalhes' />
      </Link>
    </ReactPlaceholder>
  )
}

ViewProdutOrderDetail.propTypes = {
  parentOrderId: PropTypes.number,
  orderId: PropTypes.number,
  productId: PropTypes.number,
  ready: PropTypes.bool,
  previousRoute: PropTypes.string
}

export default ViewProdutOrderDetail



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/ProductOrderItem/ViewProdutOrderDetail/ViewProdutOrderDetail.js